export enum SYSTEM_ENUM {
    CN = 'CN',
    TW = 'TW',
    JP = 'JP',
    EN = 'EN',
    EM = 'EM',
}
export type TSystem = 'CN' | 'TW' | 'JP' | 'EN' | 'EM' | string;
export type TLang =
    | 'en-us'
    | 'ja-jp'
    | 'zh-cn'
    | 'zh-tw'
    | 'th-th'
    | 'es-es'
    | 'ko-kr'
    | 'fr-fr'
    | 'ru-ru'
    | 'id-id'
    | 'pt-br'
    | 'de-de'
    | 'it-it'
    | 'vi-vn'
    | 'sv-se'
    | 'nl-nl'
    | 'ar-ae'
    | 'he-il'
    | string;

export enum LANG_ENUM {
    'zh-cn' = 'zh-cn',
    'zh-tw' = 'zh-tw',
    'en-us' = 'en-us',
    'ja-jp' = 'ja-jp',
    'th-th' = 'th-th',
    'es-es' = 'es-es',
    'ko-kr' = 'ko-kr',
    'fr-fr' = 'fr-fr',
    'ru-ru' = 'ru-ru',
    'id-id' = 'id-id',
    'pt-br' = 'pt-br',
    'de-de' = 'de-de',
    'it-it' = 'it-it',
    'vi-vn' = 'vi-vn',
    'sv-se' = 'sv-se',
    'nl-nl' = 'nl-nl',
    'ar-ae' = 'ar-ae',
    'he-il' = 'he-il',
}

type LangMapItem = {
    short: string;
    value: TLang;
    label: string;
};

export interface I18Config {
    langs_full: LangMapItem[];
    system_langs: TLang[];
    systems: TSystem[];
}

export const getDefaultSystemLang = (system: TSystem) => {
    switch (system) {
        case SYSTEM_ENUM.CN:
            return LANG_ENUM['zh-cn'];
        case SYSTEM_ENUM.TW:
            return LANG_ENUM['zh-tw'];
        case SYSTEM_ENUM.JP:
            return LANG_ENUM['ja-jp'];
        case SYSTEM_ENUM.EN:
            return LANG_ENUM['en-us'];
        case SYSTEM_ENUM.EM:
            return LANG_ENUM['en-us'];
        default:
            return LANG_ENUM['en-us'];
    }
}

export const LANG_SHORT_MAP: Record<TLang, string> = {};

export const LANG_SHORT_REVERSE_MAP: Record<string, TLang> = {};

export const LANG_TEXT_MAP: Record<TLang, string> = {};

export const i18nConfig: I18Config | undefined = (window as any)?.pageData?.config?.i18n_config;
if (i18nConfig) {
    i18nConfig.langs_full.forEach((item) => {
        LANG_SHORT_MAP[item.value] = item.short;
        LANG_SHORT_REVERSE_MAP[item.short] = item.value;
        LANG_TEXT_MAP[item.value] = item.label;
    });
}

type LangListItem = { key: TLang; value: string };
export function getLangSwitchList(): LangListItem[] {
    if (i18nConfig?.system_langs.length) {
        const ans: LangListItem[] = [];
        i18nConfig.system_langs.forEach((value: TLang) => {
            const label = LANG_TEXT_MAP[value];
            ans.push({
                key: value,
                value: label,
            });
        });
        return ans;
    }

    return [];
}
